<template>
<div>
   <div :class="$style['basic-message']">
    <div v-if="isBatch">本次共为{{resultContent.approveTotal}}个用户发放奖励，现金奖励共计{{resultContent.moneyRewardTotal}}元，
      优惠券奖励共计{{resultContent.couponRewardTotal}}张，{{resultContent.couponRewardMoneyTotal}}元。
      本次奖励发放失败老用户{{resultContent.failedOldUserTotal}}个，失败新用户{{resultContent.failedNewUserTotal}}个。</div>
    <wt-table :labels="awardResultTableLabel" :list="resultContent.failedDetailList"></wt-table>
  </div>
  <div class="button-div">
        <el-button type="primary" @click="submit" :loading="submitLoading">确认</el-button>
  </div>
</div>
</template>
<script>
import { awardResultTableLabel } from './award-audit.js'
export default {
  props: {
    resultContent: {
      type: [Object, String],
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      awardResultTableLabel: awardResultTableLabel
    }
  },
  methods: {
    submit () {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style module lang="less">

</style>
